'use client';

import { Field } from '@chakra-ui/react';

import { useFormError } from '../../../hooks';
import type { FormFieldProps, FormValues } from '../../../types';

export const FormField = <T extends FormValues>(props: FormFieldProps<T>) => {
	const {
		children, helperText, label, name, optionalText, ...rest
	} = props;
	const { errorText, isError, isSubmitting } = useFormError(name);
	const Component = isError ? Field.ErrorText : Field.HelperText;
	const text = isError ? errorText : helperText;

	return (
		<Field.Root disabled={isSubmitting} invalid={isError} {...rest}>
			<Field.Label>
				{label}
				<Field.RequiredIndicator fallback={optionalText} />
			</Field.Label>
			{children}
			{text && (
				<Component minH="14px" ml={1} textStyle="caption">
					{text}
				</Component>
			)}
		</Field.Root>
	);
};
